import _ from 'lodash';

import { typePoeCamera } from '../../../../utils/constant';

// Read the numeric `value` at `<path>.value` from an object, defaulting to 0.
export const getObjectValue = (obj, path) => _.get(obj, `${path}.value`, 0);

// Set `<path>.<key>` (defaults to `value`) on an object.
export const setObjectValue = (obj, path, value, key = 'value') =>
  _.set(obj, `${path}.${key}`, value);

// Sum the qty of POE-camera fields within a section, filtered by `keyPredicate`.
export const getPoeCameraCountInSection = (fieldsObj, sectionName, keys, keyPredicate) =>
  keys
    .filter(k => {
      const section = fieldsObj[sectionName];
      const field = section && section[k];
      return field && field.productType === typePoeCamera && keyPredicate(k);
    })
    .reduce((acc, k) => acc + parseInt(fieldsObj[sectionName][k].value || 0, 10), 0);
